module.exports = __webpack_public_path__ + "static/media/lavadeira-rio-ecommerce-site.da27890a.jpg";